import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React from 'react';
import { collapsedAtom } from '../store';
const BtnWrapper = styled.div`
  height: 24px;
  width: 24px;
  background-color: var(--color-fill-1);
  color: var(--color-text-3);
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  // 位置
  position: absolute;
  bottom: 12px;
  right: 12px;

  &:hover {
    background-color: var(--color-fill-3);
  }
`;
export const CollapseBtn = () => {
  const [collapsed, seCollapsed] = useAtom(collapsedAtom);
  return /*#__PURE__*/React.createElement(BtnWrapper, {
    onClick: () => seCollapsed(!collapsed)
  }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null));
};